import axios from 'axios';
import authHeader from './auth-header';
const config = require("../config/config.js");

const API_URL = config.API_URL + 'user/';

class UserService {
  getPublicContent() {
    return axios.get(API_URL + 'all');
  }

  getUserBoard() {
    return axios.get(API_URL + 'user', { headers: authHeader() });
  }

  getModeratorBoard() {
    return axios.get(API_URL + 'mod', { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(API_URL + 'admin', { headers: authHeader() });
  }
  getListUser() {
    return axios.get(API_URL + 'listuser', { headers: authHeader() });
  }
  getUserFiltered(data) {
    return axios.post(API_URL + 'listuserfiltered', data, { headers: authHeader() });
  }
  setSaldo(checkedIds, saldo) {
    return axios.post(API_URL + 'setsaldo', {checkedIds, saldo}, { headers: authHeader() });
  }
  getListSupervisor() {
    return axios.get(API_URL + 'listuser?supervisor=1', { headers: authHeader() });
  }
  getBalance() {
    return axios.get(API_URL + 'getbalance', { headers: authHeader() });
  }
  getListUserFull() {
    return axios.get(API_URL + 'listuserfull', { headers: authHeader() });
  }
  getListSupervisorFull() {
    return axios.get(API_URL + 'listsupervisorfull', { headers: authHeader() });
  }
  getUser(iduser) {
    return axios.post(API_URL + 'userbyid', {iduser:iduser},{ headers: authHeader() });
  }
  edit(user) {
    return axios.post(API_URL + 'edit', user,{ headers: authHeader() });
  }

  checkin(id) {
    console.log("user.service.checkin()");
    console.log(id);
    var res = axios.post(API_URL + 'checkin', {id:id},{ headers: authHeader() });
    console.log(res);
    return res;
  }
  changepwd(user) {
    console.log("user.service.changepwd()");
    console.log(user);
    var res = axios.post(API_URL + 'changepwd', user,{ headers: authHeader() });
    console.log(res);
    return res;
  }
}

export default new UserService();
